module.exports = __webpack_public_path__ + "static/media/evolve-logo.12150a5c.gif";